/**
 * Parse ISO date string
 *
 * This convoluted mess is necessary because lovely Safari doesn't use the
 * local time zone during `new Date(…)`!
 * @param {'YYYY-MM-DD'} date Date string
 * @param {'HH:MM:SS'} time Time string
 * @returns {Date} Parsed date
 */
export default function (date, time) {
  const segements = [
    ...date.split('-'),
    ...time.split(':')
  ].map(item => parseInt(item))

  // The second number is the month which is 0-based, so we have to decrement
  // value we get from the ISO string.
  segements[1] = --segements[1]

  return new Date(...segements)
}
